<template>
    <el-col class="left_nav">
        <el-menu
            :default-active="current"
            class="el-menu-vertical-demo nav_left"
            :router="true"
            @open="handleOpen"
            @close="handleClose"
            @select="handelSelect"
        >
            <el-menu-item
                :class="sub_id == items.id ? 'left_bg' : 'false'"
                v-for="items in sub_menu"
                :key="items.id"
                :index="'/' + items.menu_router"
                @click="jumpLeft(items.menu_router, items.id)"
            >
                <i
                    v-if="items.menu_icon"
                    class="fa"
                    :style="{ color: '#' + items.icon_color }"
                    :class="items.menu_icon.slice(1, -1)"
                ></i>
                <span>{{ items.menu_name }}</span>
            </el-menu-item>
        </el-menu>
    </el-col>
</template>
<style scoped lang="scss">
.fa {
    margin-right: 5px;
    font-size: 20px;
    color: #409eff;
}

.el-aside {
    width: 110px;
    height: 100%;
}

.left_nav {
    height: 100%;
}

.nav_left {
    width: 100%;
}

.el-menu-item:hover {
    background: #dbe7f7;
    color: #165dff;
}

.left_bg {
    background-color: #dbe7f7 !important;
}
</style>
<script setup name="LeftNav">
import { useStorage } from '@vueuse/core'
import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useIndexSore } from '@/store/modules/app'
import { storeToRefs } from 'pinia' //引入pinia
// import svgIcon from './svgIcon.vue';
const router = useRouter()
const store = useIndexSore()
const { subMenuState, subMenuId, styleHeight } = storeToRefs(store)
const current = ref('1-1')

const sub_menu = computed(() => subMenuState.value)
const sub_id = computed(() => subMenuId.value)

let curr = useStorage('current')
current.value = curr.value ? curr.value : '1-1'

const handleOpen = function (key, keyPath) {
    console.log(key, keyPath)
}
const handleClose = function (key, keyPath) {
    console.log(key, keyPath)
}
const handelSelect = function (key, keyPath) {
    current.value = keyPath[1]
    useStorage('current', current.value)
}
const jumpLeft = function (url, id) {
    localStorage.setItem('subMenuId', id)
    subMenuId.value = id
    router.push(url)
}
</script>
